import { render, staticRenderFns } from "./CalendarAsideRoomStatus.vue?vue&type=template&id=8a538064&scoped=true&"
import script from "./CalendarAsideRoomStatus.vue?vue&type=script&lang=js&"
export * from "./CalendarAsideRoomStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a538064",
  null
  
)

export default component.exports